/* Trick or Fits — theme behaviour
   - Fade-in on scroll (.reveal)
   - All universes filter + search ([data-universes])
   - Collection product-type filter ([data-type-filters])
   Re-initialises when sections are edited in the theme editor. */
(function () {
  'use strict';

  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-in)');
    var animated = document.body.classList.contains('tof-anim') && ('IntersectionObserver' in window);
    var editorReload = !!root && window.Shopify && window.Shopify.designMode;
    if (!animated || editorReload) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initUniverses(root) {
    (root || document).querySelectorAll('[data-universes]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var cards = wrap.querySelectorAll('[data-universe-card]');
      var chips = wrap.querySelectorAll('[data-kind-filter]');
      var input = wrap.querySelector('[data-universe-search]');
      var empty = wrap.querySelector('[data-universe-empty]');
      var kind = 'all';

      function apply() {
        var q = input ? input.value.trim().toLowerCase() : '';
        var shown = 0;
        cards.forEach(function (card) {
          var okKind = kind === 'all' || card.dataset.kind === kind;
          var okQ = !q || card.dataset.name.indexOf(q) !== -1;
          var show = okKind && okQ;
          card.hidden = !show;
          if (show) { shown++; card.classList.add('is-in'); }
        });
        if (empty) empty.hidden = shown !== 0;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          kind = chip.dataset.kindFilter;
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          apply();
        });
      });
      if (input) input.addEventListener('input', apply);
    });
  }

  function initTypeFilters(root) {
    (root || document).querySelectorAll('[data-type-filters]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var grid = document.querySelector(bar.dataset.target);
      if (!grid) return;
      var chips = bar.querySelectorAll('[data-type]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var type = chip.dataset.type;
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          grid.querySelectorAll('[data-product-type]').forEach(function (card) {
            var show = type === 'all' || card.dataset.productType === type;
            card.hidden = !show;
            if (show) card.classList.add('is-in');
          });
        });
      });
    });
  }

  function initAll(root) {
    initReveal(root);
    initUniverses(root);
    initTypeFilters(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
